import React from 'react';
import { InfoIcon, InfoIconPurple } from '../../@theme/assets/svg/icons';
import { AgreementContainerStyled as AgreementContainer, AgreementIconContainerStyled as AgreementIconContainer } from './styles/AgreementStyled';
;
var iconVariants = {
  bubblegum: React.createElement(InfoIcon, null),
  corporate: React.createElement(InfoIconPurple, null)
};
var Agreement = function Agreement(_ref) {
  var _iconVariants$variant;
  var children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'bubblegum' : _ref$variant;
  return React.createElement(AgreementContainer, null, React.createElement(AgreementIconContainer, null, (_iconVariants$variant = iconVariants[variant]) !== null && _iconVariants$variant !== void 0 ? _iconVariants$variant : React.createElement(InfoIcon, null)), children);
};
export default Agreement;